/**
 * @generated SignedSource<<21b0fae93b75690b41206fdc3876e33f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserCashback",
        "kind": "LinkedField",
        "name": "cashbackWallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "activeAmount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RecurringCreditCard",
    "kind": "LinkedField",
    "name": "recurringCreditCards",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cardNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookScreenQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BookScreenQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "791b70530252df67509359a590c2f2b7",
    "id": null,
    "metadata": {},
    "name": "BookScreenQuery",
    "operationKind": "query",
    "text": "query BookScreenQuery {\n  user {\n    cashbackWallet {\n      activeAmount\n    }\n  }\n  recurringCreditCards {\n    cardNumber\n    token\n  }\n}\n"
  }
};
})();

node.hash = "716375460e61daea99387995b7c91835";

module.exports = node;
